<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<a id="page_4">
<h3 style="margin-top:3em!important;"><img alt="image" src="images/logo1.jpg"/><em>Contents</em><img alt="image" src="images/logo2.jpg"/></h3>
</a><p class="paracenter" style="font-size:1.1em!important; margin-top:2.5em!important;"><a id="page_4"></a><a href="#/text/05a_author#anote" id="anote">Author’s Note</a></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><a href="#/text/07_part1#pt1" id="pt1">Building the Privateer <em>Prince de Neufchatel</em></a></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><a href="#/text/08_chapter1#ch1" id="ch1">Introduction</a></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><a href="#/text/09_chapter2#ch2" id="ch2">The Masterclass</a></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><span href="#/text/10_chapter3#ch3" id="ch3" title="Link target outside of Sample">The Model Gallery</span></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><span href="#/text/11_epilogue#epi" id="epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><span href="#/text/12_materialsandtools#mat" id="mat" title="Link target outside of Sample">Materials and Tools</span></p>
<p class="paracenter" style="margin-top:1.5em!important; margin-bottom:0.5em!important;"><img alt="image" src="images/logo3.jpg"/></p>
<p class="paracenter" style="font-size:1.1em!important;"><span href="#/text/13_furtherreading#fr" id="fr" title="Link target outside of Sample">Further Reading</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_toc.vue?4a733f6a